export * from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals/modal-publish-portals-error.store.ts"